import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var rotateStyle = 'fx_2d2fb1e5_6h2w3m6';
var spinnerSize = 'var(--fx_2d2fb1e5_6h2w3m0)';
var spinnerStyle = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_6h2w3m1',variantClassNames:{size:{small:'fx_2d2fb1e5_6h2w3m2','default':'fx_2d2fb1e5_6h2w3m3',large:'fx_2d2fb1e5_6h2w3m4'}},defaultVariants:{size:'default'},compoundVariants:[]});

export { rotateStyle, spinnerSize, spinnerStyle };
//# sourceMappingURL=spinner.vanilla.mjs.map
